module.exports = __webpack_public_path__ + "4c5ad34d46002f1fd52ac65dfd50854a.svg";